<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto pa-4" height="280">
      <v-card-text>
        <div class="text-p font-weight-bold mb-4">{{ type }}</div>
        <table class="" dense>
          <tbody>
            <tr>
              <td>Quant. de Dados Cadastrados</td>
              <td>{{ series[0] }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "CensoCard",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      series: [0, 0], // [preenchido, nao preenchido]
    };
  },
  computed: {
    preenchidoPercent() {
      const total = this.series[0] + this.series[1];
      return total > 0 ? ((this.series[0] / total) * 100).toFixed(1) : 0;
    },
  },
  mounted() {
    this.getGenero();
  },
  methods: {
    async getGenero() {
      const response = await this.$services.alunosService.generos();
      const payload = Object.values(response.data);

      this.series = [parseInt(payload[0], 10), parseInt(payload[1], 10)];

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.v-table th {
  background-color: #f5f5f5;
}

.v-table td,
.v-table th {
  padding: 12px;
}
</style>
